/**
 * Configuration for Panel priorities and identifiers in the Settings Panel Engine system.
 *
 * @description
 * This configuration defines the priority levels for different panel types in the settings application.
 * Higher numbers indicate higher priority levels when managing panel visibility and interactions.
 *
 * The priority values are used to determine:
 * - Panel horizontal ordering
 * - Panel priority in the tray
 *
 * Priority values are automatically assigned to SettingsPanelPortals based on this configuration,
 * so they don't need to be manually passed to SettingsPanelPortal components.
 *
 * @type {Record<string, number>}
 * The type `SettingsPanelConfig` is derived from this configuration and serves as the identifier type
 * for panel instances throughout the settings application.
 */

export const settingsPanelPriority = {
  // Add your settings panel identifiers and priorities here
  // Example:
  // 'account-settings': 5,
  // 'preferences': 4,
  // 'notifications': 3,
  test: 1,
  'ai-receptionist-test-panel': 2,
} as const satisfies Record<string, number>;

export type SettingsPanelConfig = keyof typeof settingsPanelPriority;
